import { MAX_PLANS_TO_COMPARE_NEW } from 'core/constants/compareNumberPlans'
import { preventOnCloseEvent } from 'core/services/onClose'
import compare from 'ENROLL/quotes/components/compare'
import visitedPlans from 'sites/enroll.pivothealth.com/quotes/components/compare/visitedPlans'
import store from 'utils/store/withMiddleware'

function handleCompare() {
  const state = store.getState()
  const newId = this.getAttribute('id')
  const [planId, period, policies] = newId.split('-')
  const extendedId = `${planId}-${period}${policies}`
  const { plansToCompare } = state

  const index = plansToCompare.findIndex(id => id === newId || id === extendedId)

  const id = plansToCompare[index] || newId

  window.dataLayerPushEvent(`SELECT_PLAN_COMPARE_QUOTE-${id}`)

  if (index >= 0) {
    return
  } else if (plansToCompare.length < MAX_PLANS_TO_COMPARE_NEW) {
    plansToCompare.push(id)
    visitedPlans.addPlan(id)
  }
  preventOnCloseEvent()
  store.update({ plansToCompare }, true)
  compare.renderCompare()
}

export default handleCompare
